<template>
  <div class="home">
    <HeaderGlobal :secondaryHeader="false" :qtSomos="qtSomos" />
    <!-- Page Content Desktop -->

    <div class="container-fluid">
      <div class="container container-content border-left-light pt-md-5 pb-5">
        <div class="row">
          <div class="col-lg-6 pl-md-5 pr-md-0 px-5">
            <h1 class="text-first-color extra-bold mt-2 mb-4 mw-350">{{ $t('get_in_touch') }}</h1>
          </div>

          <div class="col-lg-6 pt-1 pl-5" id="formc">
            <h4 class="mt-3 mb-4 text-second-color extra-bold">{{ $t('fill_fields_below') }}</h4>

            <!--@submit="checkForm" novalidate="true"-->
            <div>
              <vs-alert
                v-if="errors.length"
                class="mb-3 mt-2"
                color="#ffffff"
                :active="inputInvalid"
              >
                <!--bf9f61-->
                <b>Por favor:</b>
                <ul class="common-list">
                  <li v-for="error in errors" :key="error.questid">{{ error.msg }}</li>
                </ul>
              </vs-alert>
              <vs-alert v-if="msgok" class="mb-3 mt-2" color="#ffffff" :active="msgok">
                <!--bf9f61-->
                <b>
                  <strong>{{ $t('message_sent_successfuly') }}</strong>
                </b>
              </vs-alert>
              <div class="col-md-11 pl-0">
                <div class="form-group my-4 my-md-0">
                  <label class="form-group has-float-label">
                    <input
                      type="text"
                      class="form-control form-control-home fcmobile"
                      id="fullName"
                      placeholder=" "
                      v-model="fullName"
                    />
                    <span class="white" for="fullName">{{ $t('full_name') }} *</span>
                  </label>
                </div>
                <div class="form-group my-4 my-md-0">
                  <label class="form-group has-float-label">
                    <input
                      required
                      type="email"
                      class="form-control form-control-home fcmobile bg-none"
                      id="email"
                      placeholder="nome@email.com.br"
                      v-model="email"
                    />
                    <span class="white" for="email">{{ $t('email') }} *</span>
                  </label>
                </div>
                <div class="form-group my-4 my-md-0">
                  <label class="form-group has-float-label">
                    <input
                      required
                      type="text"
                      class="form-control form-control-home fcmobile bg-none"
                      id="cpf"
                      placeholder="XXX.XXX.XXX-XX"
                      v-model="cpf"
                      v-mask="'###.###.###-##'"
                    />
                    <span class="white" for="CPF">CPF *</span>
                  </label>
                </div>
                <div class="form-group my-4 my-md-0">
                  <label class="form-group has-float-label">
                    <input
                      type="tel"
                      class="form-control form-control-home fcmobile "
                      id="telefone"
                      placeholder="(xx) 9xxxx-xxxx"
                      v-model="phone"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                    />
                    <span class="white" for="telefone">{{ $t('tel') }}</span>
                  </label>
                </div>
                <div class="form-group">
                  <select class="form-control form-control-home" id="formSelect" v-model="topic">
                    <option class="text-black" value disabled selected>{{ $t('select_subject') }} *</option>
                    <option class="text-black" >{{ $t('questions') }}</option>
                    <option class="text-black" >{{ $t('infos') }}</option>
                    <option class="text-black" >{{ $t('change_of_registration') }}</option>
                    <option class="text-black" >{{ $t('deletion_of_registration') }}</option>
                  </select>
                </div>
                <div class="form-group my-4 my-md-0">
                  <label class="form-group has-float-label">
                    <textarea
                      class="form-control form-control-home text-light fcmobile bg-none"
                      id="message"
                      placeholder=" "
                      v-model="message"
                      rows="5"
                    />
                    <span class="white" for="mesage">{{ $t('message') }} *</span>
                  </label>
                </div>

                <!-- <button type="submit" class="btn btn-primary mt-4 mb-4 transparent">Quero fazer parte</button> -->
                <!--type="submit"-->
                <button class="btn btn-home btn-block mt-4 mb-2" :style="template.style.homeBtnColor ? {backgroundColor: template.style.homeBtnColor} : ''" v-on:click="checkForm">
                  {{btnMes}}
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="processingApi"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterGlobal :secondaryFooter="false" :qtSomos="qtSomos" />
  </div>
</template>
<script>
import HeaderGlobal from "./HeaderGlobal.vue";
import FooterGlobal from "./FooterGlobal.vue";

import { Survey } from "../services/Survey.js";
const s = new Survey();

import { mask } from "vue-the-mask";

export default {
  name: "Home",
  components: {
    HeaderGlobal,
    FooterGlobal
  },
  data: () => ({
    backgroundLoading: "primary",
    colorLoading: "#fff",
    fullName: "",
    message: "",
    topic: "",
    email: "",
    cpf: "",
    phone: "",
    errors: [],
    qtErros: 0,
    qtSomos: 0,
    n: [],
    msgok: false,
    processingApi: false
  }),
  directives: { mask },
  created() {
    this.qtSomos = this.$store.state.qtUsers;
    this.$gtag.event("Contact", { method: "Google" });
  },
  beforeMount() {
    if (!this.$store.state.template.style) {
      this.$nextTick(() => {
        this.$router.push('home')
      })
    }
  },
  mounted() {
    //if (localStorage.cpf) {
    //  this.cpf = localStorage.cpf;
    // }
  },
  watch: {},
  computed: {
    btnMes() {
      if (this.processingApi) return "Processando...";
      else return "Enviar";
    },
    inputInvalid() {
      if (this.qtErros == 0) return false;
      else return true;
    },
        template() {
      return this.$store.state.template
    },
  },

  methods: {
    ErrorOccured(value, id) {
      var payload = { questid: id, msg: value };
      if (this.errors) {
        var found = false;
        for (var i = 0; i < this.errors.length; i++) {
          if (this.errors[i].questid == id) {
            this.errors[i] = payload;
            found = true;
          }
        }
        if (!found) {
          this.errors.push(payload);
          this.qtErros++;
        }
      } else {
        this.qtErros++;
        this.errors.push(payload);
      }
    },
    RemoveError(id) {
      if (this.errors)
        for (var i = 0; i < this.errors.length; i++) {
          if (this.errors[i].questid == id) {
            this.errors.splice(i, 1);
            this.qtErros--;
          }
        }

      if (this.errors.length == 0) {
        this.errors = [];
        this.qtErros = 0;
      }
    },

    checkForm: function() {
      this.errors = [];

      if (!this.fullName) this.ErrorOccured("Informe seu nome completo.", 1);

      if (!this.cpf) {
        this.ErrorOccured("Informe seu CPF.", 2);
      } else {
        if (!this.TestaCPF(this.cpf))
          this.ErrorOccured("Verifique, CPF Inválido", 2);
      }

      //if (!this.phone) this.ErrorOccured("Informe seu número de celular.", 3);

      if (!this.email) this.ErrorOccured("Informe seu endereço de email.", 4);

      if (!this.topic) this.ErrorOccured("Informe o motivo do seu contato.", 5);

      if (!this.message) this.ErrorOccured("Escreve sua mensagem.", 6);

      if (this.errors.length) {
        var element = document.getElementById("formc");
        element.scrollIntoView();
        return false;
      } else {
        this.msgok = false;
        this.processingApi = true;
        //this.submit()
        s.SendContact(
          this.fullName,
          this.cpf,
          this.phone,
          this.topic,
          this.message,
          this.email
        ).then(
          ret => {
            if (ret) this.msgok = true;
            var element = document.getElementById("formc");
            this.processingApi = false;
            element.scrollIntoView();
          },
          err => {
            this.processingApi = false;
            this.ErrorOccured(err, 1);
          }
        );
      }

      //    e.preventDefault();
    },

    TestaCPF: function(strCPF) {
      var Soma;
      var Resto;
      Soma = 0;
      strCPF = strCPF.replace(/[^\d]/g, "");
      if (strCPF == "00000000000") return false;
      if (strCPF == "11111111111") return false;
      if (strCPF == "22222222222") return false;
      if (strCPF == "33333333333") return false;
      if (strCPF == "44444444444") return false;
      if (strCPF == "55555555555") return false;
      if (strCPF == "66666666666") return false;
      if (strCPF == "77777777777") return false;
      if (strCPF == "88888888888") return false;
      if (strCPF == "99999999999") return false;
      var i;
      for (i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },

    submit() {}
  }
};
</script>

<style lang="scss" scoped>
.text-black {
  color: #000
}
#formSelect {
  height: 48px;
  background-color: transparent;
  border: 1px solid var(--first-color);
  font-size: 1rem;
  color: white;
  &:focus {
    border: none !important;
    box-shadow: 0 0 0 0.2rem var(--first-color);
    text-decoration: none;
    color: #fff;
  }
  &:valid {
    background-color: transparent;
    opacity: 1;
  }
}
</style>
